import { render } from "./VideoModal.vue?vue&type=template&id=6c86db3a"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=6c86db3a&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__